// ============================================================
// PayRocky - Safe storage helpers
// Wrap browser storage access so stricter browsers like Safari
// do not break app boot when storage is unavailable or limited.
// ============================================================

export function readStorageJSON(key, fallback) {
  if (typeof window === 'undefined') return fallback;

  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (_) {
    return fallback;
  }
}

export function writeStorageJSON(key, value) {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (_) {
    return false;
  }
}

export function removeStorageItem(key) {
  if (typeof window === 'undefined') return false;

  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (_) {
    return false;
  }
}

export function readCachedValue(key, maxAgeMs, fallback) {
  const cached = readStorageJSON(key, null);
  if (!cached || typeof cached !== 'object') return fallback;
  if (typeof cached.savedAt !== 'number') return fallback;
  if (Date.now() - cached.savedAt > maxAgeMs) return fallback;
  return Object.prototype.hasOwnProperty.call(cached, 'value') ? cached.value : fallback;
}

export function writeCachedValue(key, value) {
  return writeStorageJSON(key, {
    value,
    savedAt: Date.now(),
  });
}
